// Notifications.jsx
import React from "react";
import "./Notifications.css";
import { ChevronRight, ChevronLeft } from "lucide-react";
import InnerHeader from "../../components/InnerHeader";
export default function Notifications() {
  const notifications = [
    {
      date: "2026-01-13",
      title: "১০ লাখ টাকার ডিজিটালি সাপ্তাহিক মেগাড্রাইভ",
      desc: "কি ভাবে, কখন এবং কোথায় আপনি অংশগ্রহণ করতে পারবেন...",
      unread: true,
    },
    {
      date: "2026-01-11",
      title: "উইকেন্ড বোনাস: ১০ কোটি টাকা!",
      desc: "কি ভাবে, কখন এবং কোথায় খেলোয়াড়েরা অংশ নিতে পারে...",
      unread: true,
    },
    {
      date: "2026-01-09",
      title: "৳২০ Crore Cash Bonanza!",
      desc: "কি ভাবে, কখন এবং কিভাবে ম্যাচ জিতে ক্যাশআউট করবেন...",
      unread: true,
    },
    {
      date: "2026-01-05",
      title: "চেইন ফ্রি চাই কিনুন!",
      desc: "কি ভাবে, কখন এবং কিভাবে চেইন অফারটি পাবেন...",
      unread: true,
    },
    {
      date: "2026-01-04",
      title: "বছর জুড়ে নতুন কিছু—আপনার জন্য স্পেশাল",
      desc: "কি ভাবে, কখন এবং কিভাবে নতুন সুবিধা পাবেন...",
      unread: true,
    },
  ];

  return (
    <div className="app">
      <InnerHeader
        title="Notifications"
      />

      <div className="lists-dep">
        {notifications.map((n, i) => (
          <div className="item" key={i}>
            <div className="content">
              <span className="date">{n.date}</span>
              <h3 className="title">{n.title}</h3>
              <p className="desc">{n.desc}</p>
            </div>
            {n.unread && <span className="dot" />}
          </div>
        ))}
      </div>

      <button className="edit">Edit</button>
    </div>
  );
}
